import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { FocuspayReportingService } from 'src/app/core/services/focuspay-reporting.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { DatacapBatchRecord } from 'src/app/shared/models/DTO/FocusPayDatacap/DatacapReportSummary.dto';
import { GenericLabelValue } from 'src/app/shared/models/DTO/GenericLabelValue.dto';
import { BatchListComponent } from './batch-list/batch-list.component';
import { CreditDashboardHeaderComponent } from './credit-dashboard-header/credit-dashboard-header.component';

@Component({
	selector: 'app-credit-dashboard',
	templateUrl: './credit-dashboard.component.html',
	styleUrls: ['../../commandcenter.scss'],
})
export class CreditDashboardComponent implements OnInit, OnDestroy {
	@ViewChild('creditDashboardHeader') creditDashboardHeader: CreditDashboardHeaderComponent;
	@ViewChild('batchListComponent') batchListComponent: BatchListComponent;
	batchRecords: DatacapBatchRecord[] = [];
	batchRecordSubscription: Subscription;

	displayDashboard: boolean = true;

	merchantIdList: GenericLabelValue[];
	merchantIdSelected: string;

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		private focuslink: FocuslinkService,
		public focusPayReportingService: FocuspayReportingService
	) {}
	ngOnDestroy(): void {
		this.batchRecordSubscription.unsubscribe();
	}

	ngOnInit(): void {
		console.clear();
		this.merchantIdSelected = this.venueService.subscriptionVenue.value.ccProcessorApiKey;
		this.batchRecordSubscription = this.focusPayReportingService.batchRecords.subscribe((batchRecords) => {
			this.batchRecords = batchRecords;
		});

		this.batchRecordSubscription.add(
			this.venueService.licenses.subscribe((data) => {
				if (data?.length > 0 && data.some((license) => license.features.overrideCreditCardApiKey)) {
					this.merchantIdList = [
						{
							label: 'Primary Account',
							value: this.venueService.subscriptionVenue.value.ccProcessorApiKey,
						},
					];
					this.merchantIdList = this.merchantIdList.concat(
						data
							.filter((license) => license.features.overrideCreditCardApiKey)
							.map((license) => {
								return {
									label: license.features.overrideCreditCardApiKey,
									value: license.features.overrideCreditCardApiKey,
								};
							})
					);
				}
			})
		);
	}

	changeMerchantId(event) {
		this.focusPayReportingService.batchRecords.next([]);
		this.batchListComponent.fetchAdditionalRecords({ first: 0, rows: 10 });
	}
}
